import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const CheckoutCompleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .img-container {
    overflow: hidden;
    width: 100%;
    height: 580px;

    img {
      margin-top: -200px;
      width: 100%;
    }
  }

  h1 {
    font-size: 60px;
    margin-bottom: 60px;
    margin-top: 75px;
  }
  h3 {
    font-size: 24px;
    margin-bottom: 198px;
    color: ${colors.dark7};
    max-width: 66%;
  }
  h4 {
    font-size: 18px;
    margin-bottom: 12px;
    color: ${colors.dark7};
  }

  @media (max-width: ${breakpoints.xl}px) {
    .img-container {
      height: 100%;
      overflow: auto;
    }
  }

  @media (max-width: ${breakpoints.md}px) {
    .img-container {
      img {
        margin-top: -100px;
      }
    }

    h1 {
      font-size: 40px;
      margin-bottom: 40px;
      margin-top: 50px;
    }
    h3 {
      font-size: 16px;
      margin-bottom: 132px;
      color: ${colors.dark7};
      max-width: 80%;
    }
    h4 {
      font-size: 18px;
      margin-bottom: 12px;
      color: ${colors.dark7};
    }
  }
  @media (max-width: ${breakpoints.xs}px) {
    .img-container {
      img {
        margin-top: 0;
      }
    }

    h1 {
      max-width: 90%;
    }
    h3 {
      max-width: 90%;
    }
  }
`
